import React, { useEffect, useState } from 'react';
import AppPlaceholder from '../../../assets/images/icons/app-media-placeholder.svg';
import { SingleAppModel } from '../../single-app/models/response/single-app.model';
import { InputNumber } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { workHubLicenseTypes } from "../../../enum";
import { getWorkHubLicenseTypes } from "../../../services/workhub.service";
import { fetchWorkHubSubscriptionDetails } from '../../../store/actions'; // import your method

type Props = {
    appDetails: SingleAppModel;
    tenantUuid: string;
    widgetUuid: string;
    maxWidgetCount: number;
}

const WorkHubSubscriptionDetails = ({
                                        appDetails,
                                        tenantUuid,
                                        widgetUuid,
                                        maxWidgetCount
                                    }: Props) => {

    const [licenses, setLicenses] = useState<any[]>([]);
    const [widgetCount, setWidgetCount] = useState<number>(maxWidgetCount);
    const [licenseType, setLicenseType] = useState<string>('');
    const [licenseCount, setLicenseCount] = useState<number>(0);

    const dispatch = useDispatch();
    const subscriptionData = useSelector((state: any) => state.workhub?.subscriptionData ?? null);

    const licenseMin = licenseType === workHubLicenseTypes.CONCURRENT_USER ? 25 : 1;

    useEffect(() => {
        const fetchLicenses = async () => {
            try {
                const response = await getWorkHubLicenseTypes();
                setLicenses(response.data);
            } catch (error) {
                console.error("Error fetching workhub license types:", error);
            }
        }
        fetchLicenses();
    }, []);

    useEffect(() => {
        if (tenantUuid && widgetUuid) {
            dispatch<any>(fetchWorkHubSubscriptionDetails(tenantUuid, widgetUuid));
        }
    }, [tenantUuid, widgetUuid, dispatch]);

    useEffect(() => {
        if (subscriptionData) {
            const type =
                subscriptionData.licenseTypeName === "Named User"
                    ? workHubLicenseTypes.NAMED_USER
                    : workHubLicenseTypes.CONCURRENT_USER;

            setLicenseType(type);
            setLicenseCount(subscriptionData.licenseCount);
            setWidgetCount(subscriptionData.workFlowCount);
        }
    }, [subscriptionData]);

    return (
        <>
            <>
                <br></br>
                <h5 style={{textAlign: "left"}}>Monthly Charge</h5>
                <div className="panel-table-content-list group-list">
                    {['Named User', 'Concurrent User'].map((type) => (
                        <div key={type}>
                            <br/>
                            <div className="feature-details-title__wrapper no-shade billing-and-plans-package-select">
                                <span className="title" style={{margin: 12}}>
                                    <strong>{type}</strong>
                                </span>
                            </div>
                            <br/>
                            {licenses
                                .filter((item) => item.licenseType === type)
                                .map((item) => (
                                    <div className="panel-table-list-item card" key={item.uuid}>
                                        <div className="panel-table-listing-item__inner">
                                            <div className="feature-details__wrapper">
                                                <div
                                                    className="card app-media-holder"
                                                    style={{backgroundImage: `url(${AppPlaceholder})`}}
                                                ></div>
                                                <div
                                                    className="feature-details-title__wrapper no-shade billing-and-plans-package-select">
                                                    <span className="title">{item.title}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel-table-listing-item__inner">
                                            <div className="panel-table-right-align-item__wrapper">
                                                <div className="panel-table-right-align-item">
                                                    <span className="title">Rs. {item.rental}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    ))}
                </div>
            </>
            <br></br>
            <div className="panel-table-content-list">
                <h5 style={{textAlign: "left"}}>Setup Fee</h5>
                <br></br>
                <div className="panel-table-list-item card">
                    <div className="panel-table-listing-item__inner">
                        <div className="feature-details__wrapper">
                            <div className="feature-details-title__wrapper no-shade">
                                <span className="title">Hosting & License, Implementation and Other Fees + Tax</span>
                                <span className="small-desc">Setup Fee</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br></br>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3">
                        <label htmlFor="licenseType" className="form-label">
                            Select the license type below.
                        </label>

                        <div className="icon-inside left d-flex btn-with-group">
                            <select
                                id="licenseType"
                                className="form-control"
                                value={licenseType}
                                disabled
                            >
                                <option value="" disabled hidden>
                                    Select license type
                                </option>
                                <option value={workHubLicenseTypes.NAMED_USER}>Named User</option>
                                <option value={workHubLicenseTypes.CONCURRENT_USER}>Concurrent User</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3 ">
                        <label htmlFor="" className="form-label">
                            Enter the number of workflows to be activated for your subscription.
                        </label>
                        <div className="icon-inside left d-flex btn-with-group">
                            {appDetails && appDetails.groupDetails[0] && <InputNumber
                                style={{width: "50%"}}
                                min={0}
                                precision={0}
                                value={widgetCount}
                                readOnly
                            />}
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3 ">
                        <label htmlFor="" className="form-label">
                            Enter the number of licenses.
                        </label>
                        <div className="form-element__wrapper mb-3 ">
                            <small style={{marginBottom: 20}}><em>Note : License cost will be calculated based on the
                                number of licenses entered by the customer.</em></small>
                        </div>
                        <div className="icon-inside left d-flex btn-with-group">
                            <InputNumber
                                style={{width: "50%"}}
                                min={licenseMin}
                                precision={0}
                                value={licenseCount}
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3 ">
                        <label htmlFor="" className="form-label" style={{fontWeight: 600}}>
                            Total subscription monthly rental (without tax & other component fees)
                        </label>
                        <div className="icon-inside left d-flex btn-with-group">
                            <InputNumber
                                value={subscriptionData?.monthlyRental || 0}
                                style={{width: "50%"}}
                                bordered={true}
                                readOnly
                                min={0}
                                precision={2}
                                addonBefore="Rs."
                            />
                        </div>
                        <div className="form-element__wrapper mb-3 ">
                            <small style={{marginBottom: 20}}><em>Note : You will receive the final costing including
                                other components later.</em></small>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {WorkHubSubscriptionDetails};
